import React, { useEffect, useState } from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Images from '../Images';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function Vacsystem() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <div>
            <div>
                <Header />
                <div className='inner_page position-relative pb-5'>
                    <img src={Images.elogo} className='elogo' alt="elogo" />
                    <img src={Images.smallround} className='smallround_footer' alt='round'/>
                    <Container className='mt-5'>
                        <div className='vac_border position-relative vac_system rounded-3 py-5 px-4'>
                        <img src={Images.a1logo} className='a1logo' alt='round'/>
                        <img src={Images.a2logo} className='a2logo' alt="elogo" />
                        <img src={Images.a2logo} className='a3logo' alt="elogo" />
                            <Row>
                                <Col xl={8} xxl={10} className='mx-auto position-relative'>
                                <img src={Images.smallround} className='bot_round' alt='round'/>
                                <img src={Images.smallround} className='top_round' alt='round'/>
                                    <div className='vac_border rounded-3 py-5 px-4'>
                                        <h4 className='text-center pb-3'>The VAC system will then interpret the score as follows</h4>
                                        <div className='pb-3'>
                                            <h5>Final Decision</h5>
                                            <p className='mb-2'>EDA Coin score: 10 points (66.67%) </p>
                                            <p className='mb-2'>EDA Coin does not appear as a SCAM.  </p>
                                            <p>EDA Coin has 66.67% profitability within 4 years of this analysis. </p>
                                        </div>
                                        <div className='pb-3'>
                                            <h5>The Coin Contract Address will then pull out the following on-chain information:</h5>666666666
                                            <p className='mb-2'>Coin Symbol </p>
                                            <p className='mb-2'>Coin Blockchain </p>
                                            <p>Current Price </p>
                                        </div>
                                        <div className='pb-4'>
                                            <h5>EdaFace Rank on Listing Platform:</h5>
                                            <div className='d-flex gap-3 mt-3'>
                                                <Link to="#">
                                            <div className='vac_border rounded-2 py-3 px-3'>
                                             <p className='mb-0 fw-500'>For more Eda Coin, check it  now <br></br>
                                             on EdaFace Listing  Platforms</p>
                                            </div>
                                            </Link>
                                            <Link to="#">
                                            <div className='vac_border rounded-2 py-3 px-3'>
                                             <p className='mb-0 fw-500'>Trade Eda Coin on:  EdaFace Dex  <br></br>
                                             EdaFace P2P Market</p>
                                            </div>
                                            </Link>
                                            </div>
                                        </div>

                                        <div className='pb-1'>
                                            <h5>Disclaimer:</h5>
                                            <p className='mb-0'>Please, note that this is not investment advice, financial advice, trading advice, or any other sort  of advice. Always Do Your Own research
                                            (DYOR) before buying any digital asset. See EdaFace  Full Disclaimer here</p>
                                            </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </Container>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Vacsystem;

